import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next';

import { LyInPlaceLoading, IF } from 'lidya-common-components';
import './signup.form.container.less';
import { SignUpFormMemo } from '../../../components/default/signUp/sign.up.memo.form';
import { requests } from '../../../components/common/requests';

const initialValues = {
  firstName: '',
  lastName: '',
  email: '',
  telephone: '',
  rEmail: '',
  agreeTerms: false,
};

const FormContainer = function ({ onSubmit }) {
  const { t } = useTranslation();
  return (
    <div className="m-signupForm__container">
      <h1 className="-short_title">
        <Trans>hero.business.loan.title</Trans>
      </h1>
      <h2>
        <Trans>hero.business.loan.subtitle</Trans>
      </h2>
      <span className="a-signupForm__separator" />

      <SignUpFormMemo
        initialValues={initialValues}
        onSubmit={onSubmit}
        submitLabel={t('hero.business.loan.apply.now')}
        noRetypeEmail
      />
    </div>
  );
};

FormContainer.propTypes = {
  onSubmit: PropTypes.func,
};

FormContainer.defaultProps = {
  onSubmit: () => {},
};

const MessageContainer = function () {
  return (
    <div className="m-signupForm__container">
      <span className="a-signupForm__bigText">
        <Trans>hero.business.loan.welcome</Trans>
      </span>
      <span className="a-signupForm__separator" />
      <h1>
        <Trans>hero.business.loan.title.final</Trans>
      </h1>
      <h2>
        <Trans>hero.business.loan.subtitle.final</Trans>
      </h2>
    </div>
  );
};

export const SignUpFormContainer = function () {
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const onSubmit = useCallback(
    (values) => {
      setLoading(true);
      const params = {
        ...values,
        email_confirmation: values.email,
        register_in_sardis: true,
        country_code: 'CZ',
        first_name: values.firstName,
        last_name: values.lastName,
        phone_number: values.telephone,
        phone_prefix: values.telephone_prefix,
        firstName: undefined,
        lastName: undefined,
        rEmail: undefined,
        agreeTerms: undefined,
        telephone: undefined,
        telephone_prefix: undefined,
      };
      requests.sendRegisterRequest(params).then((response) => {
        setShowSuccess(true);
        setLoading(false);
      });
    },
    [],
  );

  return (
    <div className="m-signUp__card -form m-loadingParent">
      <LyInPlaceLoading visible={loading} />
      <div className="m-signupForm__container -submit-button-cz">
        <IF condition={!showSuccess} Else={MessageContainer}>
          <FormContainer onSubmit={onSubmit} />
        </IF>
      </div>

    </div>

  );
};

SignUpFormContainer.propTypes = {};

export default SignUpFormContainer;
